export const DraggerConstants = {
  UPLOAD_PRIMARY_TXT: "Click or drag file to this area to upload",
  getUploadHint: (largeSizeFile: boolean) =>
    largeSizeFile ? "Max file size is 25mb" : "Max file size is 5mb",
  MAX_FILE_COUNT: 1,
  DEFAULT_SHEET_STATE: "Pending",
  FILE_UPLOAD_SUCCESS_TXT: "Upload Completed!",
  PDF_ICON_ALT: "Pdf-icon",
  UPLOAD_ICON_ALT: "upload-icon",
  PROGRESS_COLOR: "#87d068",
};

export const FileUploadConstants = {
  DUPLICATE_WARNING: (fileName: string) =>
    `${fileName} is already uploaded. Do you want to upload it again?`,
  UPLOAD_SUCCESS: (fileName: string) => `${fileName} uploaded successfully`,
  UPLOAD_FAILED: (fileName: string) => `${fileName} upload failed`,
  DUPLICATE_TITLE: "Duplicate File",
  FILE_SIZE_WARNING: (largeSizeFile: boolean) =>
    largeSizeFile
      ? "File must be less than 25MB."
      : "File must be less than 5MB.",
  FILE_TYPE_WARNING_2: "Only PDF files are allowed.",
  FILE_TYPE_WARNING: "Only PDF files are allowed.",
  MAX_COUNT_WARNING: (maxCount: string) =>
    `You can only upload up to ${maxCount} file${Number(maxCount) > 1 ? "s" : ""}.`,
};
